import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { cloneDeep } from "lodash";

const STEPS = 0;
const DATE_FORMAT = "YYYY-MM-DD";

const OPTIONS_DEFAULTS = {
  deadlineEnabled: 0,
  challengeType: "chart",
  chartType: "goal",
  inviteAll: 0
};

const FORM_DATA_DEFAULTS = {
  between: {
    value: "individuals",
    typeForApi: "string",
    apiValues: {
      teams: "groups",
      members: "individuals"
    }
  },
  programId: {
    value: null,
    typeForApi: "number"
  },
  isAdmin: {
    value: 0,
    typeForApi: "number"
  },

  // type
  mapId: {
    value: null,
    typeForApi: "number"
  },
  isGoal: {
    value: true,
    typeForApi: "number"
  },

  // define
  challengeName: {
    value: "",
    typeForApi: "string"
  },
  startDate: {
    value: new Date(),
    typeForApi: "string",
    dateFormat: DATE_FORMAT
  },
  endDate: {
    value: new Date(),
    typeForApi: "string",
    dateFormat: DATE_FORMAT
  },
  duration: {
    value: 1,
    typeForApi: "number"
  },
  allowActivities: {
    value: STEPS,
    typeForApi: "number"
  },
  atStake: {
    value: null,
    typeForApi: "string"
  },
  featured: {
    value: 0,
    typeForApi: "number"
  },
  open: {
    value: 1,
    typeForApi: "number"
  },
  public: {
    value: 1,
    typeForApi: "number"
  },
  instant: {
    value: 0,
    typeForApi: "number"
  },
  allowAddingCompletionDate: {
    value: 0,
    typeForApi: "number"
  },
  allowFreeTextInput: {
    value: 0,
    typeForApi: "number"
  },
  // daily step goal
  // pulls from map data if map is selected
  steps: {
    value: 0,
    typeForApi: "number"
  },

  // add
  teamIds: {
    value: [],
    typeForApi: "array"
  },
  memberIds: {
    value: [],
    typeForApi: "array"
  },

  orgnizationIds: {
    value: [],
    typeForApi: "array"
  },

  includeAll: {
    value: 0,
    typeForApi: "number"
  },
  includeType: {
    value: "invite",
    typeForApi: "string"
  },
  competitionOf: {
    value: "",
    typeForApi: "string"
  },

  addCreator: {
    value: 1,
    typeForApi: "number"
  },
  trackTextAndImagePoints: {
    value: 1,
    typeForApi: "number"
  },
  trackQuestionPoints: {
    value: 1,
    typeForApi: "number"
  },
  pointsGoal: {
    value: 1,
    typeForApi: "number"
  },
  trackingCalc: {
    value: 0,
    typeForApi: "number"
  },
  // incentive
  incentivizeChallenge: {
    value: null,
    typeForApi: "number"
  },
  incentiveType: {
    value: undefined,
    typeForApi: "string"
  },
  incentiveAmount: {
    value: null,
    typeForApi: "number"
  },
  challengeUploadedImage: {
    value: null,
    typeForApi: "image"
  },
  customRecognitionWallTitle: {
    value: undefined,
    typeForApi: "string"
  },
  useCustomRecognitionWallTitle: {
    value: undefined,
    typeForApi: "number"
  }
};

const state = {
  activeStep: 1,
  formDataDefaults: cloneDeep(FORM_DATA_DEFAULTS),
  optionsDefaults: OPTIONS_DEFAULTS,
  // performing a deep clone of defaults to prevent default
  // object mutation
  options: cloneDeep(OPTIONS_DEFAULTS),
  formData: cloneDeep(FORM_DATA_DEFAULTS),

  // when user is done selecting which members/teams
  // they want added, we pull the ids from here
  // and save them to the formData object
  stagedTeams: [],
  stagedMembers: [],
  stagedOrganizations: [],
  packageMode: false,
  memberMode: false,
  teamMode: false,
  selectedPackage: {},
  pointsGoalPerDay: 1
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
